<template>
  <d-modal @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        {{ $t('settings.transaltion.addTranslation') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-form>
        <validation-observer ref="customer-tag-translation-add-form" tag="form">
          <div class="form-group">
            <label>
              {{ $t('ui.language') }}:
            </label>

            <d-form-select
              v-model="language"
              :options="languageOptions" />
          </div>

          <div class="form-group">
            <label>
              {{ $t('settings.customerTags.tagName') }}:
            </label>

            <validation-provider
              rules="required"
              name="name"
              v-slot="{ errors }">
              <d-input
                :state="errors.length ? 'invalid' : null"
                v-model="name" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group">
            <label for="name">
              {{ $t('settings.customerTags.tagDescription') }}:
            </label>

            <validation-provider
              rules="required"
              name="intro"
              v-slot="{ errors }">
              <d-input
                :state="errors.length ? 'invalid' : null"
                v-model="description" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </validation-observer>
      </d-form>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        @click.prevent="cancel">
        {{ $t('ui.cancel') }}
      </d-button>
      <d-button
        class="ml-auto"
        theme="success"
        @click.prevent="validateForm">
        <i class="material-icons">add</i>
        {{ $t('settings.transaltion.addTranslation') }}
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'customer-tag-translation-new-popup',
  props: {
    customerTagID: {
      default: 0,
      type: Number
    },
    languages: {
      default: () => ([]),
      type: Array
    }
  },
  computed: {
    languageOptions () {
      return this.languages.map(language => ({
        value: language.id,
        text: language.name
      }));
    }
  },
  data () {
    return {
      language: this.languages[0].id,
      name: '',
      description: ''
    };
  },
  methods: {
    handleClose (newTranslationID = false) {
      this.$bus.$emit('customer-tag-translation-new-popup-close', newTranslationID);
    },
    validateForm () {
      FormUtils.validate(this.$refs['customer-tag-translation-add-form'], this.saveTranslation);
    },
    saveTranslation () {
      FormUtils.submit({
        $http: this.$http,
        endpoint: '/customers/tags/translations/store',
        formData: {
          customer_tag_id: this.customerTagID,
          language_id: this.language,
          name: this.name,
          description: this.description
        },
        successTitle: this.$t('settings.transaltion.addTranslationSuccessTitle'),
        successText: this.$t('settings.transaltion.addTranslationSuccessText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('settings.transaltion.addTranslationErrorText'),
        successAction: res => {
          this.$bus.$emit('customer-tag-reload-translations');
          this.handleClose(res.id);
        }
      });
    },
    cancel () {
      this.handleClose();
    }
  }
}
</script>
